"use client";

import SSDINavbar from "./ssdi-services/Navbar";
import Hero from "./ssdi-services/Hero";
import Dyq from "./ssdi-services/Dyq";
import Hta from "./ssdi-services/Hta";
import Fas from "./ssdi-services/Fas";
import Wcb from "./ssdi-services/Wcb";
import Gst from "./ssdi-services/Gst";
import Faq from "./ssdi-services/Faq";
import Footer from "./ssdi-services/Footer";
import Popup from "./ssdi-services/Popup";

import { useEffect, useState } from "react";

import {
  ensureMetaPixel,
  trackEventWithUserData,
} from "../../utils/metaPixel";

export default function SSDILawsuit() {
  const META_PIXEL_ID = "";//
  const [htaVisible, setHtaVisible] = useState(false);

  useEffect(() => {
    const section = document.getElementById("hta-section");

    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHtaVisible(true);
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <main className="w-full overflow-x-hidden bg-white">

      {/* POPUP (must be inside component) */}
      {/* <Popup triggerFromSection={htaVisible} /> */}

      <SSDINavbar />
      <Hero />
      <Dyq />

      {/* Hta wrapped for observer */}
      <div id="hta-section">
        <Hta />
      </div>

      <Fas />
      <Wcb />
      <Gst />
      <Faq />
      <Footer />

    </main>
  );
}